export const formatTimestamp = (timestamp: string) =>
  new Date(parseInt(timestamp)).toLocaleDateString();
